import React from "react"

export const EnglishTos = () => (
  <div className="tos">
    <h1>
      General Terms of Use
    </h1>
    <blockquote>
      <p>
        <span>
        APPROACHING CULTURES SL., (from now on called <em>Chinespain</em>) 
          is a company registered in Spain, with
          fiscal id B87285037, with the registered address Calle
          Hermanos del Moral, 79, 2B, 28019, Madrid, registered in the
          Registro Mercantil de Madrid, hoja B-133269, Tomo 43102,
      Folio 166 .</span>
      </p>
      <p>
        <span>Please send any questions related to these Terms to </span> 
        <strong>
          <a href= "mailto:hola@chinespain.com">
            <span className="underline">hola@chinespain.com</span>
          </a>.
        </strong>
      </p>
      <p>
        <span>The website </span> 
        <a href="http://zhangshangxby.com">
          <span className="underline">zhangshangxby.com</span>
        </a> 
        <span> offers tickets to museums, sporting events, transportation, tables
      and menus in restaurants, or trips.</span>
      </p>
      <p>
        <span>The usage of this website makes you a <em>user</em>,
        and implies the acceptance of these Terms of Sale and Terms
        of Use, in the published form at the time the user accesses
      the website.</span>
      </p>
      <p>
        <span>The user declares themselves in full legal capacity
        to act and purchase in this website according to these
        conditions, which they also declare understand and
      accept.</span>
      </p>
      <p>
        <span>The user is takes responsibility for providing their
        information correctly in the purchase processes available in
        zhangshangxby, paying special attention to the introduction
        of personal information, and the information required to
        provide the service and delivering the acquired products or
      services.</span>
      </p>
      <p>
        <span><em>Chinespain</em>, according to its privacy policy,
        commits itself to, in the usage of the information included
        in its files, respecting your confidentiality and using this
        information according to its intended use, fulfilling its
        obligation of protecting them and taking the appropriate
        measures to avoid its alteration, loss, or unauthorized
        treatment or access, as its stablished in the current laws of
        personal data protection. The information provided and stored
        in our data base is protected by systems that prevent its
      access by unauthorized third parties.</span>
      </p>
      <p>
        <span>The sale process is made for payment, with all the
        information relevant to the price of each ticket or product
        available at all times on the website. This information is
      provided free of charge.</span>
      </p>
      <p>
        <span>ChineSpain intends to provide developers, promoters
        and the broad Chinese public of a channel for the acquisition
        of tickets, in the Chinese language, but under no
        circumstance acts as promoter entity of the events or
      services.</span>
      </p>
      <p>
        <strong><br /></strong>
      </p>
    </blockquote>
    <h2>
      01. General
  </h2>
    <blockquote>
      <p>
        <strong>1.1</strong>
        &nbsp;We sell tickets and products and / or associated services
        on behalf of promoters, producers, teams, venues or premises.
        We designate as "Promoter" "Provider" persons or entities
        that organize or celebrate the show or activity and / or that
        provide us with tickets and / or associated products or
        services to sell them.
    </p>
    </blockquote>
    <h2>
      02. Contract
  </h2>
    <blockquote>
      <p>
        <strong>2.1</strong>
        &nbsp;Any purchase of an article of ours is governed by: (i)
        these General Purchase Conditions; (ii) any kind of special
        terms and conditions that may be published on our website;
        and (iii) the terms and conditions of the Promoter (s) and
        Suppliers of the show / activity, which may be consulted on
        their respective websites.
    </p>
      <p>
        <strong>2.2</strong> 
        &nbsp;Your contract to purchase an Activity starts when we
        confirm your purchase and ends when the service ends or you
        enjoy the entry / activity.
    </p>
      <p>
        <strong>2.3</strong>
        &nbsp;We reserve the right to cancel reservations that we
        reasonably suspect have been made fraudulently.
    </p>
    </blockquote>
    <h2>
      03. Confirmation of purchase and Acquisition of tickets
  </h2>
    <blockquote>
      <p>
        <strong>3.1</strong> 
        &nbsp;If your purchase has been made correctly, you will
        receive on your phone and in your e-mail an SMS and
        confirmation email with detailed information about the
        purchase you have just made. A few minutes later you will
        receive another sms and e-mail with the absolute confirmation
        of your purchase and the tickets or vouchers necessary to
        enjoy the activity. The presentation of your tickets or
        bonuses on your phone is absolutely mandatory for the
        enjoyment of the activity
    </p>
      <p>
        &nbsp;If the purchased item is a transport, you will also receive
        immediate confirmation of the waiting time for it.
    </p>
      <p>
        <strong>3.2</strong> In case of telephone loss or a similar issue, Chinespain
        has its contact information on its website to help solve this
        type of incident.
    </p>
    </blockquote>
    <h2>
      04. Other delivery options
  </h2>
    <blockquote>
      <p>
        <strong>4.1</strong> 
        &nbsp;Our goal is to send tickets as soon as possible.
        Sometimes the tickets or bonuses can not be sent immediately,
        but our team will be in direct contact via SMS or e-mail to
        inform you of the delivery.
    </p>
    </blockquote>
    <h2>
      05. Prices and expenses
  </h2>
    <blockquote>
      <p>
        <strong>5.1</strong> 
        &nbsp;The final purchase price of each item on our website will
        be that specified during the purchase process, management
        fees already included.
    </p>
    </blockquote>
    <h2>
      06. Cancellations by the buyer and returns
  </h2>
    <blockquote>
      <p>
        <strong>6.1</strong> 
        &nbsp;Tickets purchased through our website can not be
        returned, unless the buyer immediately contacts us to inform
        us of any errors in date, number of people or schedule.
    </p>
      <p>
        <strong>6.2</strong> 
        &nbsp;By courtesy, Chinespain grants 15 'margin for ticket
        cancellation and dismissal of table reservations. In the case
        of transport, the request for an immediate car (by it through
        Uber, Cabify or Taxi) can not be canceled.
    </p>
      <p>
        If you cancel your purchase within the established time,
        Chinespain will refund the entire purchase through the same
        means of payment for which you made the purchase within 1-5
        business days.
    </p>
    </blockquote>
    <h2>
      07. Chages in activities
  </h2>
    <blockquote>
      <p>
        <strong>7.1</strong> 
        &nbsp;In the event of cancellation or change of date of an
        activity, we will use all means reasonably available to
        communicate the cancellation and proceed to change or refund
        the amount paid immediately.
    </p>
    </blockquote>
    <h2>
      08. Refunds
  </h2>
    <blockquote>
      <p>
        <strong>8.1</strong> <strong>Cancellation</strong>: If an event is canceled by 
        the promoter you will be offered a refund of the total sale price 
        of the activity purchased.
    </p>
      <p>
        <strong>8.2</strong> 
        <strong>Change of date or time</strong>: If the date of an event were to
        change, you will be offered an alternative date or time. If this new 
        arrangement is not viable, you will be offered a total refund of your 
        tickets. For this purpose, Chinespain will contact the buyer through SMS
        or e-mail. If the buyer does not answer in a reasonable time considering
        the new date and time of the event, ChineSpain may not make any refunds.
    </p>
    </blockquote>
    <h2>
      09. Liability
  </h2>
    <blockquote>
      <p>
        <strong>9.1</strong> 
        &nbsp;Personal plans, including travel, accommodation or
        benefits, in relation to the activity you have hired on your
        own, are at your own risk. We do not assume any
        responsibility, and neither does the Promoter (s), for any
        loss of the right of enjoyment or lost expense (loss of
        flights, trains, change of plans ...).
    </p>
    </blockquote>
    <h2>
      10 Admission and attendance
  </h2>
    <blockquote>
      <p>
        <strong>10.1</strong> 
        &nbsp;The venue reserves the right to refuse admission in case
        of breach by customers of any of the terms and conditions of
        the activity or the Promoter / Provider. The site will be
        obliged at times to perform security related queries in order
        to ensure the safety of customers. The entrance or entrances
        are emitted in agreement with the norms and regulations of
        the enclosure and of the Promoter / Provider of the activity.
    </p>
      <p>
        <strong>10.2</strong> 
        &nbsp;Every effort will be made to allow access to people who
        arrive late to activities, but admission can not always be
        guaranteed.
    </p>
      <p>
        <strong>10.3</strong> 
        &nbsp;In some activities the unauthorized use of photographic
        and recording equipment is prohibited. Photos, videos and /
        or recordings may be destroyed or deleted. Laser pens, mobile
        phones, pets (except guide dogs) and the customer's own food
        and drink may also be prohibited (you must consult the
        venue).
    </p>
    </blockquote>
    <h2>
      11. Questions and complaints
  </h2>
    <blockquote>
      <p>
        <strong>11.1</strong> If you have any doubt or complaint regarding your
        purchase, please contact us, citing the number of your phone
        or email used for the purchase.
    </p>
      <p>
        <strong>11.2</strong> 
        &nbsp;Since we sell activities / tickets on behalf of
        Promoters / Providers, we may need to contact them to gather
        more information before responding to your complaint. The
        resolution of some complaints may take up to 28 days, but we
        will contact you as soon as possible.
    </p>
      <p>
        <strong>11.3</strong> 
        &nbsp;In case of any conflict, we will try diligently to
        consult or negotiate in good faith, and we will try to reach
        a transactional agreement that is fair and equitable for your
        interests, ours, and those of the Promoter / Provider.
    </p>
    </blockquote>
    <h2>
      12. Miscellaneous
  </h2>
    <blockquote>
      <p>
        <strong>12.1</strong> 
        &nbsp;All these terms and conditions are governed by Spanish
        law and any dispute arising from any operation with
        Chinespain will be subject to the exclusive jurisdiction of
        the Spanish courts.
    </p>
      <p>
        <strong>12.2</strong> 
        &nbsp;These Conditions and its general conditions of contract,
        together with the specific conditions that may be
        established, expressly regulate the relations between
        Chinespain and the third parties (hereinafter "users") that
        contract through the portal&nbsp;www.zhangshangxby.com
    </p>
      <p>
        <strong>12.3</strong> 
        &nbsp;These General Conditions have been prepared in accordance with the 
        provisions of Law 34/2002, of July 11, on services of the information society 
        and electronic commerce; Law 7/1998, of April 13, on General Conditions of Contract; 
        Royal Decree-Law 1/2007, of November 16, approving the revised text of the
        General Law for the Defense of Consumers and Users and other complementary laws and Law 7/1996,
        of January 15, Ordination of Retail Trade, as well as however many legal provisions are applicable.
    </p>
      <p>
        <strong>12.4</strong> 
        &nbsp;If any clause included in these general conditions is
        declared, totally or partially, null or ineffective, such
        nullity or inefficacy will affect only that provision or the
        part of it that is null or ineffective, the general
        conditions remaining in effect the rest of these conditions,
        having such disposition, or the part of it that was affected,
        as not included.
    </p>
      <p>
        Date: 10/10/2018
    </p>
    </blockquote>
  </div>
)

export const SpanishTos = () => (
  <div className="tos">
    <h1>Condiciones Generales de Uso</h1>
    <blockquote>
      <p>
        <span>APPROACHING CULTURES SL., (a.k.a Chinespain) sociedad
        registrada en España, con número de identificación fiscal
        B87285037, con domicilio social en Calle Hermanos del Moral,
        79, 2B, 28019, Madrid e inscrita en el Registro Mercantil de
        Madrid, hoja B-133269, Tomo 43102, Folio 166 .</span>
      </p>
      <p>
        <span>Cualquier duda relacionada con estas Condiciones de
        Compra pueden remitirla a <a href=
        "mailto:hola@chinespain.com"><span className=
        "underline">hola@chinespain.com</span></a></span>
      </p>
      <p>
        <span>A través de zhangshangxby.com podrás comprar entradas
        a museos y espectáculos deportivos, reservar un transporte,
        reservar mesa y menú en un restaurante o reservar una
        excursión.</span>
      </p>
      <p>
        <span>La utilización de la Web atribuye la condición de
        usuario e implica la aceptación de las disposiciones
        incluidas en estas Condiciones Generales de Compra y
        Condiciones de Uso en la versión publicada por Approaching
        Cultures SL, a partir de ahora <em>Chinespain</em>, en el
        mismo momento en que el usuario acceda a la
        web.&nbsp;</span>
      </p>
      <p>
        <span>El usuario declara que dispone de capacidad legal
        necesaria para actuar y contratar en la web de acuerdo con
        las condiciones más abajo desglosadas, las cuales declara
        comprender y aceptar.&nbsp;</span>
      </p>
      <p>
        <span>El usuario es el responsable de facilitar sus datos
        correctamente en los procesos de compra establecidos en la
        página web de zhangshangxby, debiendo prestar especial
        atención en cuanto a la introducción de los datos de carácter
        personal y de envío de la compra adquirida.</span>
      </p>
      <p>
        <span><em>Chinespain</em>, de acuerdo con su política de
        privacidad, se compromete, en la utilización de los datos
        incluidos en el fichero, a respetar su confidencialidad y a
        utilizarlos de acuerdo con la finalidad del fichero, así como
        a dar cumplimiento a su obligación de guardarlos y adaptar
        todas las medidas para evitar la alteración, pérdida,
        tratamiento o acceso no autorizado de acuerdo con lo
        establecido en la legislación vigente referente a la
        protección de datos de carácter personal. Los datos
        suministrados y almacenados en nuestras bases de datos se
        encuentran igualmente protegidos por sistemas de seguridad
        que impiden el acceso de terceros no autorizados a los
        mismos.</span>
      </p>
      <p>
        <span>El servicio de venta de entradas es de carácter
        oneroso, disponiendo el usuario de toda la información
        relativa al precio de cada entrada en todo momento en la web.
        El servicio de información ofrecido a través de la web es de
        carácter gratuito.&nbsp;</span>
      </p>
      <p>
        <span>Chinespain pretende facilitar a promotores y al
        público chino en general un canal de adquisición de entradas,
        en idioma chino, pero en ningún momento actúa como entidad
        promotora del evento o espectáculo.</span>
      </p>
    </blockquote>
    <h2>
      01. General
    </h2>
    <blockquote>
      <p>
        1.1 Vendemos entradas y productos y/o servicios asociados en
        nombre de promotores, productores, equipos, recintos o
        locales. Denominamos como “Promotor” “Proveedor” a personas o
        entidades que organizan o celebran el espectáculo o actividad
        y/o que nos facilitan entradas y/o productos o servicios
        asociados para vendérselos.&nbsp;
      </p>
    </blockquote>
    <h2>
      02. Contrato
    </h2>
    <blockquote>
      <p>
        2.1 Toda compra de un Artículo nuestro se rige por: (i) estas
        Condiciones Generales de Compra; (ii) cualquier clase de
        términos y condiciones especiales que puedan publicarse en
        nuestra web; y (iii) los términos y condiciones de lo(s)
        Promotor(es) y Proveedores del espectáculo/actividad, que
        podrán consultarse en sus respectivas webs.
      </p>
      <p>
        2.2 Tu contrato de compra de una Actividad se inicia cuando
        confirmamos tu compra y finaliza en cuanto termina el
        servicio o disfrute de la entrada/actividad.
      </p>
      <p>
        2.3 Nos reservamos el derecho de anular reservas que
        sospechemos razonablemente que se han realizado de forma
        fraudulenta.
      </p>
    </blockquote>
    <h2>
      03. Confirmación de compra y Adquisición de entradas
    </h2>
    <blockquote>
      <p>
        3.1 Si tu compra se ha realizado correctamente, recibirás en
        tu teléfono y en tu e-mail un sms y correo de confirmación
        con información detallada de la compra que acabas de
        realizar. Unos minutos más tarde recibirás otro sms e e-mail
        con la confirmación absoluta de tu compra y las entradas o
        bonos necesarios para disfrutar de la actividad. La
        presentación de tus entradas o bonos en tu teléfono es
        completamente obligatorio para el disfrute de la actividad.
      </p>
      <p>
        Si el articulo comprado es un transporte, recibirás también
        confirmación inmediata del tiempo de espera para el mismo.
      </p>
      <p>
        3.2 En caso de pérdida del teléfono o situación similar,
        <em>Chinespain</em> cuenta en su web con un contacto para
        ayudar a solventar este tipo de incidencias.
      </p>
    </blockquote>
    <h2>
      04. Otras opciones de entrega de entradas
    </h2>
    <blockquote>
      <p>
        4.1 Nuestro objetivo es proceder al envío de las entradas lo
        antes posible. En algunas ocasiones las entradas o bonos no
        pueden enviarse inmediatamente, pero nuestro equipo estará en
        contacto directo vía sms o e-mail para informarte de la
        entrega y/o envío.
      </p>
    </blockquote>
    <h2>
      05. Precios y gastos
    </h2>
    <blockquote>
      <p>
        5.1 El precio final de compra de cada artículo de nuestra web
        será el especificado durante el proceso de compra, gastos de
        gestión ya incluidos.
      </p>
    </blockquote>
    <h2>
      06. Cancelaciones por parte del comprador y devoluciones
    </h2>
    <blockquote>
      <p>
        6.1 Las entradas compradas a través de nuestra web no podrán
        ser devueltas, a excepción de que el comprador se ponga en
        contacto inmediatamente con nosotros para informarnos de
        algún error en fecha, número de personas u horario.
      </p>
      <p>
        6.2 Por cortesía, <em>Chinespain</em> otorga 15’ de margen
        para cancelación de entradas y desestimación de reserva de
        mesa. En el caso de transportes, la petición de un coche
        inmediato (Uber, Cabify, Taxi) no podrá ser cancelada.
      </p>
      <p>
        Si cancela su compra dentro del tiempo establecido,
        <em>Chinespain</em> le devolverá la totalidad de su compra a
        través del mismo medio de pago por el cual efectuó la compra
        en un plazo de 1-5 días hábiles.
      </p>
      <p>
        Cuánto nos cobra payexpert?
      </p>
    </blockquote>
    <h2>
      07. Cambios en actividades
    </h2>
    <blockquote>
      <p>
        7.1 En el supuesto de cancelación o cambio de fecha de una
        actividad, utilizaremos todos los medios que estén
        razonablemente a nuestro alcance para comunicarte la
        cancelación y proceder al cambio o reembolso del importe
        pagado inmediatamente.
      </p>
    </blockquote>
    <h2>
      08. Devoluciones
    </h2>
    <blockquote>
      <p>
        8.1&nbsp;<strong>Cancelación:</strong>&nbsp;Si se cancela una
        actividad por parte del promotor se te ofrecerá la devolución
        del precio total de venta de la actividad adquirida.
      </p>
      <p>
        8.2 <strong>Cambio de fecha:</strong>&nbsp;Si se cambia la
        fecha de una actividad, se ofrecerá disfrutarla en otro día u
        horario. En caso de no poder disfrutarla en la nueva fecha u
        horario, se te ofrecerá la devolución del precio total de
        venta de la actividad adquirida. Para esto,
        <em>Chinespain</em> se pondrá en contacto con el comprador a
        través de sms o e-mail. Si el comprador no responde en un
        plazo considerable, teniendo en cuenta la nueva fecha de la
        actividad, <em>Chinespain</em> no devolverá el importe de la
        actividad adquirida.
      </p>
    </blockquote>
    <h2>
      09. Responsabilidad
    </h2>
    <blockquote>
      <p>
        9.1 Los planes personales, incluidos viajes, alojamientos o
        prestaciones, en relación con la actividad que hayas
        contratado por tu cuenta, corren de tu cuenta y riesgo. No
        asumimos ninguna responsabilidad, y tampoco lo hace(n) lo(s)
        Promotor(es), por cualquier pérdida del derecho de disfrute o
        gasto perdido&nbsp;(pérdida de vuelos, trenes, cambio de
        planes…).
      </p>
    </blockquote>
    <h2>
      10 Admisión y Asistencia
    </h2>
    <blockquote>
      <p>
        10.1 El recinto se reserva el derecho a denegar la admisión
        en caso de incumplimiento por parte de los clientes de
        cualquiera de los términos y condiciones de la actividad o el
        Promotor/Proveedor. El recinto se verá obligado en ocasiones
        a realizar consultas relacionadas de seguridad con el fin de
        garantizar la seguridad de los clientes. La entrada o
        entradas se emiten de acuerdo con las normas y regulaciones
        del recinto y del Promotor/Proveedor de la actividad.
      </p>
      <p>
        10.2 Se hará todo lo posible por permitir el acceso a las
        personas que lleguen tarde a las actividades, pero no siempre
        puede garantizarse la admisión.&nbsp;
      </p>
      <p>
        10.3 En algunas actividades queda prohibido el uso no
        autorizado de equipos fotográficos y de grabación. Podrán
        destruirse o eliminarse fotos, videos y/o grabaciones.
        También podrán prohibirse los bolígrafos láser, teléfonos
        móviles, perros (salvo perros guía) y la comida y bebida
        propia del cliente (deberá consultarse con el recinto).&nbsp;
      </p>
    </blockquote>
    <h2>
      11. Dudas y quejas
    </h2>
    <blockquote>
      <p>
        11.1 Si tienes cualquier duda o queja en relación con tu
        compra, ponte en contacto con nosotros, citando el número de
        tu teléfono o email utilizado para la compra.
      </p>
      <p>
        11.2 Dado que vendemos actividades/entradas en nombre de los
        Promotores/Proveedores, es posible que tengamos que ponernos
        en contacto con éstos para recabar más información antes de
        responder a tu queja. La resolución de algunas quejas puede
        tardar hasta 28 días, pero volveremos a contactar contigo lo
        antes posible.&nbsp;
      </p>
      <p>
        11.3 En caso de producirse cualquier conflicto, procuraremos
        realizar consultas de forma diligente o negociar de buena fe,
        e intentaremos alcanzar un acuerdo transaccional que resulte
        justo y equitativo para tus intereses, los nuestros y los del
        Promotor/Proveedor.
      </p>
    </blockquote>
    <h2>
      12. Miscelánea
    </h2>
    <blockquote>
      <p>
        12.1 Todos estos términos y condiciones se rigen por el
        Derecho español y cualquier conflicto que se derive de
        cualquier operación con <em>Chinespain</em> se someterá a la
        competencia exclusiva de los órganos jurisdiccionales
        españoles.&nbsp;
      </p>
      <p>
        12.2 Estas Condiciones Generales de Compra y sus condiciones
        generales de contratación junto, en su caso, con las
        condiciones particulares que puedan establecerse, regulan
        expresamente las relaciones surgidas entre
        <em>Chinespain</em> y los terceros (en adelante "usuarios")
        que contraten a través del portal&nbsp;www.zhangshangxby.com
      </p>
      <p>
        12.3 Las presentes Condiciones Generales han sido elaboradas
        de conformidad con lo establecido en la Ley 34/2002, de 11 de
        julio, de servicios de la sociedad de la información y de
        comercio electrónico; la Ley 7/1998, de 13 de abril, sobre
        Condiciones generales de la Contratación; el Real Decreto
        Legislativo 1/2007, de 16 de noviembre, por el que se aprueba
        el texto refundido de la Ley General para la Defensa de los
        Consumidores y Usuarios y otras leyes complementarias y la
        Ley 7/1996, de 15 de enero, de Ordenación del Comercio
        Minorista, así como cuantas disposiciones legales resulten de
        aplicación.&nbsp;
      </p>
      <p>
        12.4 Si cualquier cláusula incluida en estas condiciones
        generales fuese declarada, total o parcialmente, nula o
        ineficaz, tal nulidad o ineficacia afectará tan sólo a dicha
        disposición o a la parte de la misma que resulte nula o
        ineficaz, subsistiendo las condiciones generales en todo lo
        demás, teniéndose tal disposición, o la parte de la misma que
        resultase afectada, por no puesta.
      </p>
      <p>
        Fecha: 10/10/2018
      </p>
    </blockquote>
  </div>
)

export default EnglishTos



// WEBPACK FOOTER //
// ./src/app/catalogo/pages/tos.jsx